"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyBotOrderBatchCloseType = exports.CopyBotOrderShareModeType = exports.CopyBotOrderOperationReasonByType = exports.CopyBotOrderOperationType = exports.CopyBotOrderFollowersListSortType = void 0;
var CopyBotOrderFollowersListSortType;
(function (CopyBotOrderFollowersListSortType) {
    CopyBotOrderFollowersListSortType["time_asc"] = "time_asc";
    CopyBotOrderFollowersListSortType["time_desc"] = "time_desc";
    CopyBotOrderFollowersListSortType["amount_asc"] = "amount_asc";
    CopyBotOrderFollowersListSortType["amount_desc"] = "amount_desc";
    CopyBotOrderFollowersListSortType["profit_asc"] = "profit_asc";
    CopyBotOrderFollowersListSortType["profit_desc"] = "profit_desc";
})(CopyBotOrderFollowersListSortType = exports.CopyBotOrderFollowersListSortType || (exports.CopyBotOrderFollowersListSortType = {}));
var CopyBotOrderOperationType;
(function (CopyBotOrderOperationType) {
    /** 创建资金池，资金 + */
    CopyBotOrderOperationType["ORDER_OPEN"] = "order_open";
    /** 增加金额，资金 + */
    CopyBotOrderOperationType["INVEST_IN"] = "invest_in";
    /** 减少金额，资金 - */
    CopyBotOrderOperationType["INVEST_OUT"] = "invest_out";
    /** 关单 */
    CopyBotOrderOperationType["ORDER_CLOSE"] = "order_close";
    /** 开单 */
    CopyBotOrderOperationType["SUB_ORDER_OPEN"] = "sub_order_open";
    /** 关单 */
    CopyBotOrderOperationType["SUB_ORDER_CLOSE"] = "sub_order_close";
    /** 增加保证金 */
    CopyBotOrderOperationType["SUB_ORDER_MARGIN_IN"] = "sub_order_margin_in";
    /** 减少保证金 */
    CopyBotOrderOperationType["SUB_ORDER_MARGIN_OUT"] = "sub_order_margin_out";
    /** 加仓，资金 - */
    CopyBotOrderOperationType["SUB_ORDER_INVEST_IN"] = "sub_order_invest_in";
    /** 加仓，资金 - */
    CopyBotOrderOperationType["SUB_ORDER_INVEST_OUT"] = "sub_order_invest_out";
})(CopyBotOrderOperationType = exports.CopyBotOrderOperationType || (exports.CopyBotOrderOperationType = {}));
/** 关单原因 */
var CopyBotOrderOperationReasonByType;
(function (CopyBotOrderOperationReasonByType) {
    /** 跟kol关单 */
    CopyBotOrderOperationReasonByType["FOLLOW_KOL"] = "follow_kol";
    /** 用户取消 */
    CopyBotOrderOperationReasonByType["USER_CANCEL"] = "user_cancel";
    /** 止损 */
    CopyBotOrderOperationReasonByType["LOSS_STOP"] = "loss_stop";
    /** 止盈 */
    CopyBotOrderOperationReasonByType["PROFIT_STOP"] = "profit_stop";
})(CopyBotOrderOperationReasonByType = exports.CopyBotOrderOperationReasonByType || (exports.CopyBotOrderOperationReasonByType = {}));
var CopyBotOrderShareModeType;
(function (CopyBotOrderShareModeType) {
    CopyBotOrderShareModeType["simple"] = "simple";
    CopyBotOrderShareModeType["water_line"] = "water_line";
})(CopyBotOrderShareModeType = exports.CopyBotOrderShareModeType || (exports.CopyBotOrderShareModeType = {}));
var CopyBotOrderBatchCloseType;
(function (CopyBotOrderBatchCloseType) {
    CopyBotOrderBatchCloseType["all"] = "all";
    CopyBotOrderBatchCloseType["fixed"] = "fixed";
})(CopyBotOrderBatchCloseType = exports.CopyBotOrderBatchCloseType || (exports.CopyBotOrderBatchCloseType = {}));
